import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserServices } from 'Services/axios/User.Service';
import { checkFilter } from 'Features/Common/CommonUtils';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchUsers = createAsyncThunk(
    'Users/fetchUsers',
    async (filters) => {
        try {
            let newFilter = checkFilter(filters);
            const response = await UserServices.getAll(newFilter);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const fetchHistoryReferral = createAsyncThunk(
    'Users/fetchHistoryReferral',
    async (filters) => {
        try {
            let newFilter = checkFilter(filters);
            const response = await UserServices.getHistoryReferral(newFilter);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const fetchHistoryReferralCompact = createAsyncThunk(
    'Users/fetchHistoryReferralCompact',
    async (filters) => {
        try {
            let newFilter = checkFilter(filters);
            const response = await UserServices.getHistoryReferralCompact(newFilter);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const fetchHistoryReferralMutation = createAsyncThunk(
    'Users/fetchHistoryReferralMutation',
    async (filters) => {
        try {
            let newFilter = checkFilter(filters);
            const response = await UserServices.getHistoryReferralMutation(newFilter);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const exportUsers = createAsyncThunk(
    'Users/exportUsers',
    async (filters) => {
        try {
            let newFilter = checkFilter(filters);
            const response = await UserServices.export(newFilter);
            const fileLink = response.data.file;
            window.open(fileLink, '_blank');
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const fetchUsersFiltered = createAsyncThunk(
    'Users/fetchUsersFiltered',
    async (filters) => {
        try {
            let newFilter = checkFilter(filters);
            const response = await UserServices.getAll(newFilter);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const submitUsers = createAsyncThunk(
    'Users/submitUsers',
    async (data) => {
        try {
            const formData = new FormData();
            formData.append('username', data.username);
            formData.append('name', data.name);
            formData.append('email', data.email);
            formData.append('gender', data.gender);
            formData.append('phone', data.phone);
            formData.append('parent_name', data.parent_name);
            formData.append('parent_phone', data.parent_phone);
            if (data.is_qc) {
                formData.append('is_qc', parseInt(data.is_qc));
            }
            if (data.email_verified_at) {
                formData.append('email_verified_at', data.email_verified_at === "1" ? 1 : 0);
            }
            if (data.password) {
                formData.append('password', data.password);
            }
            if (data.referral_code !== data.old_referral_code) {
                formData.append('referral_code', data.referral_code);
            }
            let response;
            if (data.isUpdate) {
                response = await UserServices.update(data.id, formData);
                toast.success('User berhasil diperbarui', {
                    position: toast.POSITION.TOP_RIGHT
                });
            } else {
                response = await UserServices.create(formData);
                toast.success('User berhasil ditambahkan', {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            data.successCallback && data.successCallback();
            return response.data.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);

export const deleteUsers = createAsyncThunk(
    'Users/deleteUsers',
    async (id) => {
        try {
            const response = await UserServices.delete(id);
            return response.data.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
);
